(function () {
  'use strict';

  var HOVER_ZOOM = 2;
  var MODAL_ZOOM = 2.4;
  var HIRES_WIDTH = 1500;

  function isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function hiResUrl(img, width) {
    var base = img.currentSrc || img.src || '';
    try {
      var u = new URL(base, window.location.href);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return base;
    }
  }

  function clamp01(n) {
    return Math.min(Math.max(n, 0), 1);
  }

  var hoverContainer = null;

  function containerOf(el) {
    if (!el || !el.closest) return null;
    var img = el.closest('.image-magnify-custom');
    return img ? img.parentElement : null;
  }

  function imgOf(container) {
    return container ? container.querySelector('.image-magnify-custom') : null;
  }

  function ensureHiRes(img) {
    if (!img || img.dataset.pzHires === '1') return;
    img.dataset.pzHires = '1';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = hiResUrl(img, HIRES_WIDTH);
  }

  function applyOrigin(container, clientX, clientY, scale) {
    var img = imgOf(container);
    if (!img) return;
    var r = container.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = clamp01((clientX - r.left) / r.width);
    var py = clamp01((clientY - r.top) / r.height);
    img.style.transformOrigin = px * 100 + '% ' + py * 100 + '%';
    img.style.transform = 'scale(' + scale + ')';
  }

  function resetImg(img) {
    if (!img) return;
    img.style.transform = '';
    img.style.transformOrigin = '';
    img.classList.remove('pz-zooming');
  }

  document.addEventListener('mouseover', function (e) {
    if (!isDesktop()) return;
    var container = containerOf(e.target);
    if (!container) return;
    hoverContainer = container;
    ensureHiRes(imgOf(container));
    applyOrigin(container, e.clientX, e.clientY, HOVER_ZOOM);
  });

  document.addEventListener('mousemove', function (e) {
    if (!hoverContainer || !isDesktop()) return;
    applyOrigin(hoverContainer, e.clientX, e.clientY, HOVER_ZOOM);
  });

  document.addEventListener('mouseout', function (e) {
    if (!hoverContainer) return;
    if (e.relatedTarget && hoverContainer.contains(e.relatedTarget)) return;
    resetImg(imgOf(hoverContainer));
    hoverContainer = null;
  });

  document.addEventListener(
    'click',
    function (e) {
      var img = e.target.closest && e.target.closest('.image-magnify-custom');
      if (!img) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(img);
    },
    true
  );

  var modal, modalStage, modalImg, modalThumbs;
  var modalImages = [];
  var modalIndex = 0;
  var modalZoomed = false;

  var mScale = 1;
  var mTx = 0;
  var mTy = 0;
  var gestureMode = null;
  var gStartDist = 0;
  var gStartScale = 1;
  var gFocalX = 0;
  var gFocalY = 0;
  var panStartX = 0;
  var panStartY = 0;
  var panStartTx = 0;
  var panStartTy = 0;
  var lastTapTime = 0;
  var lastGestureEnd = 0;

  function touchDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function touchMid(t) {
    return {
      x: (t[0].clientX + t[1].clientX) / 2,
      y: (t[0].clientY + t[1].clientY) / 2,
    };
  }

  function stageCenter() {
    var r = modalStage.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function applyModalTransform() {
    modalImg.style.transformOrigin = 'center center';
    modalImg.style.transform =
      'translate(' + mTx + 'px, ' + mTy + 'px) scale(' + mScale + ')';
    modalZoomed = mScale > 1.01;
  }

  function clampTranslation() {
    var r = modalStage.getBoundingClientRect();
    var iw = modalImg.clientWidth * mScale;
    var ih = modalImg.clientHeight * mScale;
    var maxX = Math.max(0, (iw - r.width) / 2);
    var maxY = Math.max(0, (ih - r.height) / 2);
    mTx = Math.min(Math.max(mTx, -maxX), maxX);
    mTy = Math.min(Math.max(mTy, -maxY), maxY);
  }

  function resetModalZoom(animate) {
    mScale = 1;
    mTx = 0;
    mTy = 0;
    gestureMode = null;
    modalImg.style.transition = animate ? '' : 'none';
    modalImg.style.transform = '';
    modalImg.style.transformOrigin = 'center center';
    modalZoomed = false;
    if (!animate) {
      void modalImg.offsetWidth;
      modalImg.style.transition = '';
    }
  }

  function onTouchStart(e) {
    if (isDesktop()) return;
    if (e.touches.length === 2) {
      gestureMode = 'pinch';
      modalImg.style.transition = 'none';
      gStartDist = touchDist(e.touches);
      gStartScale = mScale;
      var mid = touchMid(e.touches);
      var c = stageCenter();
      gFocalX = (mid.x - c.x - mTx) / mScale;
      gFocalY = (mid.y - c.y - mTy) / mScale;
      e.preventDefault();
    } else if (e.touches.length === 1 && mScale > 1.01) {
      gestureMode = 'pan';
      modalImg.style.transition = 'none';
      panStartX = e.touches[0].clientX;
      panStartY = e.touches[0].clientY;
      panStartTx = mTx;
      panStartTy = mTy;
    } else {
      gestureMode = null;
    }
  }

  function onTouchMove(e) {
    if (isDesktop() || !gestureMode) return;
    e.preventDefault();
    if (gestureMode === 'pinch' && e.touches.length === 2) {
      var dist = touchDist(e.touches);
      var mid = touchMid(e.touches);
      var c = stageCenter();
      var s = Math.min(Math.max(gStartScale * (dist / gStartDist), 1), 4);
      mScale = s;
      mTx = mid.x - c.x - s * gFocalX;
      mTy = mid.y - c.y - s * gFocalY;
      applyModalTransform();
    } else if (gestureMode === 'pan' && e.touches.length === 1) {
      mTx = panStartTx + (e.touches[0].clientX - panStartX);
      mTy = panStartTy + (e.touches[0].clientY - panStartY);
      clampTranslation();
      applyModalTransform();
    }
  }

  function onTouchEnd(e) {
    if (isDesktop()) return;
    modalImg.style.transition = '';
    if (gestureMode === 'pan' || gestureMode === 'pinch') {
      lastGestureEnd = Date.now();
    }
    if (e.touches.length === 0) {
      if (mScale <= 1.01) {
        resetModalZoom(true);
      } else {
        clampTranslation();
        applyModalTransform();
      }
      gestureMode = null;
    } else if (e.touches.length === 1 && mScale > 1.01) {
      gestureMode = 'pan';
      panStartX = e.touches[0].clientX;
      panStartY = e.touches[0].clientY;
      panStartTx = mTx;
      panStartTy = mTy;
    }
  }

  function onStageTap(e) {
    if (gestureMode === 'pan' || gestureMode === 'pinch') return;
    if (Date.now() - lastGestureEnd < 400) return;

    if (e.target === modalStage) {
      closeModal();
      return;
    }

    if (isDesktop()) return;

    var now = Date.now();
    if (now - lastTapTime > 300) {
      lastTapTime = now;
      return;
    }
    lastTapTime = 0;
    modalImg.style.transition = '';
    if (mScale > 1.01) {
      resetModalZoom(true);
    } else {
      var c = stageCenter();
      mScale = MODAL_ZOOM;
      mTx = (c.x - e.clientX) * (mScale - 1);
      mTy = (c.y - e.clientY) * (mScale - 1);
      clampTranslation();
      applyModalTransform();
    }
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'pz-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<button class="pz-modal__close" type="button" aria-label="Cerrar">&times;</button>' +
      '<div class="pz-modal__stage">' +
      '<img class="pz-modal__img" alt="">' +
      '<div class="pz-modal__spinner" aria-hidden="true"></div>' +
      '</div>' +
      '<div class="pz-modal__thumbs"></div>';
    document.body.appendChild(modal);

    modalStage = modal.querySelector('.pz-modal__stage');
    modalImg = modal.querySelector('.pz-modal__img');
    modalThumbs = modal.querySelector('.pz-modal__thumbs');

    modalImg.addEventListener('load', hideSpinner);
    modalImg.addEventListener('error', hideSpinner);

    modal.querySelector('.pz-modal__close').addEventListener('click', closeModal);

    modalImg.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      e.stopPropagation();
      modalZoomed = !modalZoomed;
      if (modalZoomed) {
        applyStageOrigin(e.clientX, e.clientY);
        modalImg.style.transform = 'scale(' + MODAL_ZOOM + ')';
      } else {
        modalImg.style.transform = '';
        modalImg.style.transformOrigin = 'center center';
      }
    });
    modalStage.addEventListener('mousemove', function (e) {
      if (!isDesktop() || !modalZoomed) return;
      applyStageOrigin(e.clientX, e.clientY);
    });

    modalStage.addEventListener('touchstart', onTouchStart, { passive: false });
    modalStage.addEventListener('touchmove', onTouchMove, { passive: false });
    modalStage.addEventListener('touchend', onTouchEnd, { passive: false });
    modalStage.addEventListener('touchcancel', onTouchEnd, { passive: false });
    modalStage.addEventListener('click', onStageTap);

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('pz-open')) return;
      if (e.key === 'Escape') closeModal();
    });
  }

  function applyStageOrigin(clientX, clientY) {
    var r = modalStage.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = clamp01((clientX - r.left) / r.width);
    var py = clamp01((clientY - r.top) / r.height);
    modalImg.style.transformOrigin = px * 100 + '% ' + py * 100 + '%';
  }

  function collectImages(fromImg) {
    var gallery = fromImg.closest('media-gallery') || document;
    var imgs = gallery.querySelectorAll('.product__media-item img.image-magnify-custom');
    var list = [];
    imgs.forEach(function (im) {
      list.push({
        full: hiResUrl(im, HIRES_WIDTH),
        thumb: im.currentSrc || im.src,
        alt: im.alt || '',
      });
    });
    return list;
  }

  function openModal(fromImg) {
    if (hoverContainer) {
      resetImg(imgOf(hoverContainer));
      hoverContainer = null;
    }
    resetImg(fromImg);

    if (!modal) buildModal();
    modalImages = collectImages(fromImg);
    if (!modalImages.length) return;

    var clicked = fromImg.currentSrc || fromImg.src;
    modalIndex = 0;
    for (var i = 0; i < modalImages.length; i++) {
      if (modalImages[i].thumb === clicked) {
        modalIndex = i;
        break;
      }
    }

    renderThumbs();
    showModalImage(modalIndex);
    modal.classList.add('pz-open');
    document.body.classList.add('pz-modal-open');
  }

  function renderThumbs() {
    modalThumbs.innerHTML = '';
    modalThumbs.style.display = modalImages.length > 1 ? '' : 'none';
    modalImages.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-modal__thumb' + (i === modalIndex ? ' is-active' : '');
      var thumbImg = document.createElement('img');
      thumbImg.src = item.thumb;
      thumbImg.alt = '';
      b.appendChild(thumbImg);
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        showModalImage(i);
      });
      modalThumbs.appendChild(b);
    });
  }

  function showSpinner() {
    if (!modalStage) return;
    if (!modalStage.querySelector('.pz-modal__spinner')) {
      var sp = document.createElement('div');
      sp.className = 'pz-modal__spinner';
      sp.setAttribute('aria-hidden', 'true');
      modalStage.appendChild(sp);
    }
    modalStage.classList.add('pz-loading');
  }

  function hideSpinner() {
    if (!modalStage) return;
    modalStage.classList.remove('pz-loading');
  }

  function showModalImage(i) {
    modalIndex = i;
    resetModalZoom(false);
    showSpinner();
    modalImg.alt = modalImages[i].alt;
    modalImg.src = modalImages[i].full;
    if (modalImg.complete && modalImg.naturalWidth > 0) hideSpinner();
    Array.prototype.forEach.call(modalThumbs.children, function (c, idx) {
      c.classList.toggle('is-active', idx === i);
    });
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('pz-open');
    document.body.classList.remove('pz-modal-open');
    resetModalZoom(false);
  }
})();
